import { useQuery } from "@tanstack/react-query";
import { getBlogs } from "../../../api";

const useGetBlogs = (busca: string = "", pagina: number = 1, quantidade: number = 9) => {
    
    const { data, isLoading, isError, error } = useQuery({
        queryKey: ["get_blogs", busca, pagina],
        queryFn: () => getBlogs(busca, pagina, quantidade),
        refetchOnWindowFocus: false,
        retry: false,
    });

    return {
        data,
        isLoading,
        isError,
        error,
    };
};

export default useGetBlogs;